import React, { Component } from "react";
import { connect } from "react-redux";
import { getBoundingClientRect } from "../../../utils/functions";
import { calcResizingCursors } from "../../calcResizingCursors";
import { CalcResize } from "../../dynamicDashboard/CalcReisze";
import ResiznigCursors from "../../ResizingCursors";
class EmptyColumn extends Component {
    state = {
        displayReszingCursors: false,
        showCursorHandles: false,
        displayColumnBorder: true
    };
    cursorMouseDown = (e, direction, cb) => {
        const rect = getBoundingClientRect(this.emptyColumnRef);
        e.persist();
        this.setState(
            {
                direction,
                prevClient: {
                    prevClientX: e.clientX,
                    prevClientY: e.clientY
                },
                initialPosition: {
                    x: rect.left,
                    y: rect.top,
                    width: rect.width,
                    height: rect.height,
                    top: rect.top,
                    left: rect.left,
                    right: rect.right
                },
                initalSpan: 0
            },
            () => {
                window.addEventListener("mousemove", this.cursorMouseMove);

                window.addEventListener("mouseup", this.cursorMouseUp);
            }
        );
        cb && cb();
    };
    cursorMouseMove = (ev) => {
        console.log("MOUSE MOVE");
        console.log(ev);
        let lang = this.props.lang;
        let initialPosition = { ...this.state.initialPosition };
        let prevClient = this.state.prevClient;
        let direction = this.state.direction;
        let initalSpan = this.state.initalSpan;
        const { height, position, width, spanToadd } = calcResizingCursors(
            lang,
            direction,
            initialPosition,
            prevClient,
            ev,
        );
        if (initalSpan != spanToadd) {
            console.log("CHANGE INITAL SPAN");
            this.setState({ initalSpan: spanToadd }, () => {
                if (spanToadd > initalSpan) {
                }
                if (spanToadd < initalSpan) {
                }
            });
        }

        console.log(spanToadd);
        // if (position && height && width) {
        //     this.emptyColumnRef.style.transform = `translate(${position.x}px, ${position.y}px)`;
        //     // windowRef.style.transform = `translateY(${position.y}px)`
        //     this.emptyColumnRef.style.height = height + "px";
        //     this.emptyColumnRef.style.width = width + "px";
        //     // windowRef.style.background = 'red'
        // }
    };

    cursorMouseUp = (e, direction) => {
        window.removeEventListener("mousemove", this.cursorMouseMove);
        window.removeEventListener("mouseup", this.cursorMouseUp);
    };
    componentDidMount() {
        console.log(this.emptyColumnRef);
        let rect = getBoundingClientRect(this.emptyColumnRef);
        this.setState({ emptyColumnRect: rect });
    }

    render() {
        return (
            <div
                ref={(el) => (this.emptyColumnRef = el)}
                className="page__section__epmtyColumn"
                style={{
                    border: this.state.displayColumnBorder
                        ? "1px dashed rgb(104, 99, 99)"
                        : "1px solid black",
                    flex: this.props.colSpan,
                    minHeight: 70
                }}
                onMouseEnter={() =>
                    this.setState({
                        displayColumnBorder: false,
                        showCursorHandles: true
                    })
                }
                onMouseLeave={() =>
                    this.setState({
                        displayColumnBorder: true,
                        showCursorHandles: false
                    })
                }
            >
                <div>+</div>
                <ResiznigCursors
                    showCursorHandles={this.state.showCursorHandles}
                    display={this.state.displayReszingCursors}
                    directionsNum="right"
                    cursorMouseDown={this.cursorMouseDown}
                    cursorMouseMove={this.cursorMouseMove}
                />
                <div
                    ref={(el) => (this.pointer = el)}
                    style={{
                        width: 0.1,
                        height: 0.1,
                        position: "fixed",
                        top: 0,
                        left: 0
                    }}
                ></div>{" "}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.settings.language
    };
};
export default connect(mapStateToProps)(EmptyColumn);
